import { MainLayout } from "@components/layouts/MainLayout";
import { Apple } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { Separator } from "@components/ui/separator";
import { ApplicationMetadata } from "@components/apps/apple-app-store/ApplicationMetadata";

export default function Account() {
  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<Apple className="h-6 w-6 text-blue-600" />}
            title="Apple App Store"
            subtitle="Metadata and metrics from the Apple App Store."
          />
        </div>
        <Separator className="mb-12" />
        <ApplicationMetadata />
      </div>
    </MainLayout>
  );
}
